"use client"

import { motion } from "framer-motion"
import Image from "next/image"

export function AuthImage() {
    return (
        <div className="relative hidden h-full w-full flex-col bg-primary p-10 text-white lg:flex justify-center items-center rounded-2xl overflow-hidden">
            <div className="w-full max-w-2xl relative z-10 flex flex-col items-center justify-center h-full">
                <div className="text-center mb-13 relative z-20 shrink-0">
                    <h2 className="font-bold text-[32px] leading-[1.1] text-white mb-4">
                        The Fastest Way to Build a <br /> Winning Pitch Deck
                    </h2>
                    <p className="text-blue-100 text-[14px] leading-[1.6] max-w-lg mx-auto">
                        Generate slides with proven investor-backed structure - traction, team, market, financials & more built instantly by AI.
                    </p>
                </div>

                {/* Layered Cards Visualization */}
                <div className="relative w-[400px] h-[280px] mt-4 shrink-0 scale-90 xl:scale-100 transition-transform">
                    {/* Back Card (Visionary Team) */}
                    <motion.img
                        src={"https://seedicon-dev-public-images.s3.ap-south-1.amazonaws.com/1769779225162_8zcs67m8qgx_Deck-2.png"} // Assuming Deck-2 is the "Team" or large white card
                        className="absolute top-0 right-0 w-[340px] shadow-2xl rounded-2xl z-10 transform translate-x-12 -translate-y-8"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3, duration: 0.6 }}
                        style={{ rotate: 4 }}
                    />

                    {/* Bottom/Right Card (Graph/Financials) */}
                    <motion.img
                        src={"https://seedicon-dev-public-images.s3.ap-south-1.amazonaws.com/1769779224923_s4eeiioibvh_Deck-3.png"} // Assuming Deck-3 is the graph card
                        className="absolute bottom-[-30px] right-[-30px] w-[300px] shadow-2xl rounded-2xl z-20"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4, duration: 0.6 }}
                        style={{ rotate: 1 }}
                    />

                    {/* Front Card (Proven Traction - Dark) */}
                    <motion.img
                        src={"https://seedicon-dev-public-images.s3.ap-south-1.amazonaws.com/1769779224883_f4wu39jpvjw_Deck-1.png"} // Assuming Deck-1 is the dark traction card
                        className="absolute top-[50px] left-[-30px] w-[280px] shadow-2xl rounded-2xl z-30"
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: 0.5, duration: 0.6, type: "spring" }}
                        style={{ rotate: -2 }}
                    />
                </div>

                {/* Social Proof Text */}
                <p className="font-jakarta text-blue-200 text-[14px] font-medium mt-14 text-center max-w-md leading-relaxed tracking-wide opacity-80 shrink-0">
                    Join over 500+ professionals worldwide who trust us to power their presentations.
                </p>
            </div>
        </div>
    )
}
